import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { brandLogos, brandName } from '../utils/branding';

function Login({ onLoginSuccess }) {
  const handleLoginSuccess = (credentialResponse) => {
    const decodedToken = jwtDecode(credentialResponse.credential);
    onLoginSuccess(decodedToken);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full sm:w-auto sm:max-w-md p-8 bg-white shadow-md rounded-lg mx-4">
        <div className="flex justify-center mb-6">
          <img src={brandLogos.main} alt={`${brandName} Logo`} className="h-12 object-contain" />
        </div>
        <div className="flex justify-center">
          <GoogleLogin
            onSuccess={handleLoginSuccess}
            onError={() => console.error('Login Failed')}
          />
        </div>
      </div>
    </div>
  );
}

export default Login;